import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const sentNewsListSelector = createSelector(
  (state: RootState) => state.news.sentNewsList,
  (sentNewsList) => sentNewsList,
);

export const sentNewsSelector = createSelector(
  (state: RootState) => state.news.sentNews,
  (sentNews) => sentNews,
);

export const isEnableLoadingSelector = createSelector(
  (state: RootState) => state.news.nextTokenSentNews,
  (nextTokenSentNews) => nextTokenSentNews !== '',
);

export const isInitSelector = createSelector(
  (state: RootState) => state.news.nextTokenSentNews,
  (nextTokenSentNews) => nextTokenSentNews !== null,
);
